<script>
import NextButton from 'dashboard/components-next/button/Button.vue';
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: { NextButton, Spinner },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      attachments: [],
      uploading: false,
    };
  },
  methods: {
    triggerFilePicker(accept) {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = accept;
      input.multiple = true;
      input.onchange = e => this.onFilesSelected(e.target.files);
      input.click();
    },
    openFilePicker() {
      this.triggerFilePicker('*/*');
    },
    openMediaPicker() {
      this.triggerFilePicker('image/*,video/*');
    },
    async onFilesSelected(files) {
      this.uploading = true;
      const newAttachments = [...this.attachments];
      for (const file of Array.from(files)) {
        try {
          const blobId = await this.$store.dispatch(
            'automations/uploadAttachment',
            file
          );
          newAttachments.push({ name: file.name, blobId });
        } catch {
          // skip failed uploads
        }
      }
      this.attachments = newAttachments;
      this.uploading = false;
      this.$emit('update:modelValue', this.attachments.map(a => a.blobId));
    },
    removeAttachment(index) {
      this.attachments = this.attachments.filter((_, i) => i !== index);
      this.$emit('update:modelValue', this.attachments.map(a => a.blobId));
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <div class="flex items-center gap-2">
      <NextButton
        sm
        faded
        slate
        icon="i-lucide-paperclip"
        :label="$t('AUTOMATION.ACTION.ATTACH_FILE')"
        :disabled="uploading"
        @click="openFilePicker"
      />
      <NextButton
        sm
        faded
        slate
        icon="i-lucide-image"
        :label="$t('AUTOMATION.ACTION.ATTACH_MEDIA')"
        :disabled="uploading"
        @click="openMediaPicker"
      />
      <Spinner v-if="uploading" size="small" />
    </div>
    <ul v-if="attachments.length" class="flex flex-col gap-1">
      <li
        v-for="(file, i) in attachments"
        :key="i"
        class="flex items-center justify-between px-2 py-1 text-xs bg-n-alpha-1 rounded-lg"
      >
        <span class="flex items-center gap-1 truncate">
          <i class="i-lucide-paperclip text-n-slate-11" />
          <span class="truncate">{{ file.name }}</span>
        </span>
        <button
          type="button"
          class="ml-2 text-n-slate-11 hover:text-n-ruby-11 flex-shrink-0"
          @click="removeAttachment(i)"
        >
          <i class="i-lucide-x" />
        </button>
      </li>
    </ul>
  </div>
</template>
